export const SERVICES = [
  {
    id: "it-support",
    num: "01",
    title: "IT Support & Troubleshooting",
    rate: "from £20/hr",
    rateVal: 20,
    badge: "Popular",
    color: "#00F0FF",
    description:
      "Windows setup & configuration, software installation and updates, hardware & peripheral support, email and account setup, general computer troubleshooting.",
    deliverables: ["Windows setup & optimisation", "Hardware & peripheral support", "Email & account setup", "Remote or on-site help"],
  },
  {
    id: "excel-data",
    num: "02",
    title: "Excel Solutions & Data Work",
    rate: "from £25/hr",
    rateVal: 25,
    badge: "High Demand",
    color: "#10B981",
    description:
      "Spreadsheet creation & improvement, data cleaning, formulas and calculations, VLOOKUP / HLOOKUP, pivot tables & charts, reporting, VBA basics.",
    deliverables: ["Custom dashboards & reports", "Data cleaning & deduplication", "Formulas, lookups & pivots", "VBA automation basics"],
  },
  {
    id: "word-ppt",
    num: "03",
    title: "Word & PowerPoint Documents",
    rate: "from £20/hr",
    rateVal: 20,
    badge: "Essential",
    color: "#F97316",
    description:
      "Professional document formatting, templates & styles, business reports, high-impact presentations, charts, tables and visual content.",
    deliverables: ["Document formatting & templates", "Professional presentations", "Business reports", "Charts, tables & visuals"],
  },
  {
    id: "automation",
    num: "04",
    title: "IT Projects & Automation",
    rate: "from £30/hr",
    rateVal: 30,
    badge: "Time Saver",
    color: "#A855F7",
    description:
      "Simple Python scripts, Excel VBA macros, repetitive-task automation, process improvement and small digital solutions that save hours every week.",
    deliverables: ["Python scripts & utilities", "Excel VBA macros", "Repetitive-task automation", "Workflow improvements"],
  },
  {
    id: "comp-problem-solving",
    num: "05",
    title: "Computational Problem Solving",
    rate: "from £30/hr",
    rateVal: 30,
    badge: "Specialist",
    color: "#3B82F6",
    description:
      "Breaking business and technical problems into manageable steps: inputs, processes and outputs, structured thinking and practical solution design.",
    deliverables: ["Problem decomposition", "Inputs / processes / outputs mapping", "Structured solution plans", "Technical strategy"],
  },
  {
    id: "algorithm-design",
    num: "06",
    title: "Algorithm Design",
    rate: "from £30/hr",
    rateVal: 30,
    badge: "Technical",
    color: "#EC4899",
    description:
      "Designing clear, efficient algorithms: step-by-step solution design, pseudocode, logic & decision-making, refinement and testing.",
    deliverables: ["Step-by-step logic design", "Pseudocode & flowcharts", "Decision-tree modelling", "Refinement & testing"],
  },
  {
    id: "software-dev",
    num: "07",
    title: "Software Development & Programming",
    rate: "from £35/hr",
    rateVal: 35,
    badge: "Advanced",
    color: "#38BDF8",
    description:
      "Small Python programs and scripts, basic software development, program logic & testing, and bespoke digital solutions for straightforward requirements.",
    deliverables: ["Custom Python tools", "Small bespoke applications", "Testing & debugging", "Scripting & utilities"],
  },
  {
    id: "networking",
    num: "08",
    title: "Intermediate Computer Networking",
    rate: "from £25/hr",
    rateVal: 25,
    badge: "Infrastructure",
    color: "#F59E0B",
    description:
      "Network troubleshooting, TCP/IP concepts, IP addressing & connectivity, home and small-office network support, configuration and diagnosis.",
    deliverables: ["Wi-Fi & connectivity fixes", "Router & network config", "IP addressing & diagnosis", "Home / small-office support"],
  },
];

export const PORTFOLIO = [
  {
    title: "Data & Systems Experience",
    subtitle: "3+ Years of Practical Experience",
    kind: "Real-world experience",
    category: "Data Management · Excel · Operational Systems",
    description:
      "More than three years of hands-on experience working with data, Excel spreadsheets, reporting and operational systems in real-world working environments.",
    tags: ["Excel — Level 3", "Reporting", "Operational Systems"],
    img: "https://images.pexels.com/photos/7567434/pexels-photo-7567434.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    problem:
      "Businesses run on data, but day-to-day operational information is often scattered, inconsistent or difficult to interpret — slowing down routine tasks and making decisions harder than they need to be.",
    solution:
      "Across more than three years in real working environments, I have worked daily with Excel spreadsheets, operational data, reporting and workplace systems: organising information, applying advanced spreadsheet functions, formulas and lookup functions, manipulating data and producing reports that keep day-to-day operations running smoothly.",
    tools: ["Excel — advanced functions & formulas", "Lookup functions (VLOOKUP / HLOOKUP)", "Data organisation & cleaning", "Operational reporting"],
    benefits: [
      "Accurate, organised information you can rely on",
      "Routine data tasks completed efficiently",
      "Clearer reporting to support informed decisions",
    ],
  },
  {
    title: "Applying Computing & IT Knowledge to Workplace Systems",
    subtitle: "Formal education in practical use",
    kind: "Real-world experience",
    category: "Computing & IT · Systems Analysis · Operational Support",
    description:
      "How I apply knowledge from my Level 4 Certificate of Higher Education in Computing and IT (The Open University) to understand workplace systems and complete operational and management-related tasks correctly and efficiently.",
    tags: ["CertHE Computing & IT", "Systems Analysis", "Logical Thinking"],
    img: "https://images.pexels.com/photos/5380618/pexels-photo-5380618.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    problem:
      "Operational systems can be complex. Without understanding how a system actually functions — its processes and its logic — tasks take longer, workarounds multiply and mistakes creep in.",
    solution:
      "When asked to apply my computing and IT knowledge at work, I start by examining how the system functions: understanding its processes and logic, interpreting the information it makes available, and using that understanding to determine how to accomplish the task correctly and efficiently. Management has been satisfied with the work I have completed using this approach.",
    tools: ["CertHE Computing & IT — The Open University", "Systems & process analysis", "Interpreting operational information", "Methodical task execution"],
    benefits: [
      "Tasks approached correctly the first time",
      "Better use of the systems a business already has",
      "A logical approach that transfers to new tools and processes",
    ],
  },
  {
    title: "Excel VBA Automation — Intelligent Data Sorting",
    subtitle: "A macro built for a manager at work",
    kind: "Real workplace solution",
    category: "Excel · VBA · Automation · Process Improvement",
    description:
      "A VBA macro combining my Level 3 Excel skills with the programming principles from my Computing & IT studies — capable of autonomously performing complex data-sorting tasks.",
    tags: ["Excel", "VBA", "Automation"],
    img: "https://images.unsplash.com/photo-1518773553398-650c184e0bb3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY6NzF8MHwxfHNlYXJjaHwxfHxleGNlbCUyMG1hY3JvJTIwcHJvZ3JhbW1pbmclMjBzcHJlYWRzaGVldCUyMGNvZGUlMjBkYXJrfGVufDB8fHx8MTc5MjI3OTg5OHww&ixlib=rb-4.1.0&q=85",
    problem:
      "Manually sorting and organising complex spreadsheet data is repetitive and slow, and doing it by hand each time the data changes makes inconsistencies almost inevitable.",
    solution:
      "I developed an Excel/VBA macro that applies consistent sorting rules autonomously, reducing the need for manual intervention. I built one for a manager at work, who was very pleased with the result. Creating it meant combining Excel expertise with an understanding of data structures, spreadsheet operations, computational problem-solving and system behaviour.",
    tools: ["Excel VBA", "Data structures", "Computational problem-solving", "Consistent rule-based sorting"],
    benefits: [
      "Repetitive sorting handled automatically",
      "The same rules applied consistently, every time",
      "Less manual intervention and fewer errors",
    ],
  },
  {
    title: "Python Application — Interview Response Confidence Builder",
    subtitle: "Designed, built and packaged as a desktop app",
    kind: "Personal software project",
    category: "Python · Software Development · Digital Solutions",
    description:
      "A Python application I designed and implemented to help users prepare and organise interview responses — compiled into a standalone executable so it runs as a normal desktop application.",
    tags: ["Python", "Desktop App", "Testing & Packaging"],
    img: "https://images.unsplash.com/photo-1753998941488-fc3064ab6094?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHw0fHxweXRob24lMjBjb2RlJTIwcHJvZ3JhbW1pbmclMjBkYXJrJTIwc2NyZWVuJTIwZWRpdG9yfGVufDB8fHx8MTc5MjI3OTg5OHww&ixlib=rb-4.1.0&q=85",
    problem:
      "Preparing for interviews is stressful. Many people struggle to structure their thoughts, identify relevant examples from their own experience and practise communicating their answers clearly.",
    solution:
      "I designed and built a Python application that gives users a structured way to prepare interview responses: thinking through their experience, identifying relevant examples and organising clear answers. The full development process was covered — problem identification, solution design, programming and testing — and the app was then compiled into a standalone executable file, so it can be distributed and run like any desktop program without the user ever touching Python source code.",
    tools: ["Python", "Solution design", "Testing & debugging", "Executable packaging"],
    benefits: [
      "A structured way to prepare and organise interview answers",
      "Runs like any normal desktop program — no technical setup",
      "Proof of turning a practical user need into working software",
    ],
  },
  {
    title: "WA Digital Solutions — Technology, Tutorials & Gaming YouTube Channel",
    subtitle: "An active content creation initiative",
    kind: "Content creation initiative",
    category: "Digital Content Creation · Technology Education · Microsoft Excel",
    description:
      "The WA Digital Solutions YouTube channel shares practical IT and educational content — Microsoft Excel tutorials, clear explanations of technical and engineering topics, and PC gaming highlights.",
    tags: ["YouTube", "Technology Tutorials", "Microsoft Excel", "Digital Learning", "Engineering Concepts", "PC Gaming"],
    img: "https://yt3.googleusercontent.com/ORCv0GfNgsDu6YwzZ8kVoZuoa9GFLY2Y9-zUgoplc7kgt67Q-FBD_vFsKaaOF01hvuEPeEAL=s900-c-k-c0x00ffffff-no-rj",
    link: { url: "https://www.youtube.com/@WA_DIGITAL_SOLUTIONS", label: "Visit YouTube Channel" },
    problem:
      "Technical subjects — from advanced spreadsheet techniques to how engines actually work — can feel inaccessible. Many people want to build real digital skills but find most content either too basic or too dense to follow.",
    solution:
      "The WA Digital Solutions YouTube channel is dedicated to technology, digital learning, educational content and PC gaming. It provides practical IT and educational content designed to help viewers develop digital skills and understand technical concepts — including Microsoft Excel tutorials covering intermediate and advanced techniques with an emphasis on spreadsheet skills, productivity and data handling. The channel also explores technical and engineering topics, such as clear explanations of how four-stroke spark ignition engines work, alongside PC multiplayer gameplay, action and highlights from Battlefield 4, Battlefield 6 and Call of Duty: Black Ops 6.",
    tools: ["Microsoft Excel tutorials", "Technology education", "Engineering concepts", "PC gaming highlights", "Digital communication"],
    benefits: [
      "Free, accessible technology learning for a wider audience",
      "Improved spreadsheet skills, productivity and data handling",
      "A growing platform for sharing knowledge and developing the WA Digital Solutions brand",
    ],
  },
  {
    title: "Microsoft Office & Business Data Solutions",
    subtitle: "Improve what you already have",
    kind: "Skills showcase",
    category: "Excel · Word · PowerPoint · Reporting",
    description:
      "Practical Microsoft Office skills to improve how information is organised, analysed and presented — spreadsheets, reporting layouts, professional documents and presentations.",
    tags: ["Excel — Level 3", "Word", "PowerPoint"],
    img: "https://images.pexels.com/photos/8062289/pexels-photo-8062289.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    problem:
      "Many individuals and small businesses already rely on spreadsheets and documents, but they have grown messy, are hard to maintain, or simply don't present information as well as they could.",
    solution:
      "I improve what you already have rather than rebuilding from scratch: Excel spreadsheets with formulas, data cleaning, lookup functions, pivot tables and charts; professionally formatted Word documents; and clear, well-structured PowerPoint presentations. This is backed by my Level 3 Excel skills, advanced Microsoft Office qualifications and practical experience working with data in operational environments.",
    tools: ["Excel — pivots, lookups & charts", "Word — professional formatting", "PowerPoint — presentations", "Data cleaning & reporting layouts"],
    benefits: [
      "Better organised information and reporting",
      "Professional documents without starting from scratch",
      "Clearer communication of the data you already hold",
    ],
  },
];

export const QUALIFICATIONS = [
  {
    title: "Professional Member (MBCS)",
    org: "BCS, The Chartered Institute for IT",
    note: "Registered professional member of the chartered body for computing — bound by the BCS Code of Conduct and committed to continuing professional development. Membership no. 995132799, valid until 15/07/2027.",
    featured: true,
  },
  {
    title: "CertHE in Computing & IT",
    org: "The Open University",
    note: "Certificate of Higher Education covering computing fundamentals, systems and problem-solving.",
  },
  {
    title: "ICDL Advanced / IT User Skills",
    org: "International Computer Driving Licence",
    note: "Advanced certified digital skills across productivity software and IT user practices.",
  },
  {
    title: "Level 3 Advanced Office",
    org: "Excel, Word & PowerPoint",
    note: "Advanced-level qualifications in spreadsheets, documents and presentations.",
  },
  {
    title: "3+ Years Practical Experience",
    org: "Real-world operational environments",
    note: "Hands-on experience with data, reporting, operational systems and digital tools in live working environments.",
  },
];

export const WHY_POINTS = [
  { title: "Professional & reliable", note: "Agreed scope, clear quote and dependable delivery — no surprises." },
  { title: "Clear, friendly communication", note: "Plain English, no jargon. You always know what is happening and why." },
  { title: "Practical, solutions-focused", note: "Real fixes for real problems — not expensive over-engineering." },
  { title: "Tailored support", note: "Solutions shaped around how you actually work, not a one-size-fits-all package." },
  { title: "Flexible working", note: "Evening and weekend availability alongside remote and on-site options." },
  { title: "Competitive prices", note: "Transparent hourly rates from £20 — professional help without IT-department costs." },
];

export const AREAS = [
  "Birmingham City Centre",
  "Digbeth",
  "Jewellery Quarter",
  "Edgbaston",
  "Harborne",
  "Selly Oak",
  "Sutton Coldfield",
  "Solihull",
  "Wolverhampton",
  "Walsall",
  "West Bromwich",
  "Dudley",
  "Stourbridge",
  "Halesowen",
  "Coventry",
  "Remote — UK-wide",
];

export const NAV_LINKS = [
  { label: "Services", id: "services" },
  { label: "Pricing", id: "pricing" },
  { label: "Work", id: "work" },
  { label: "About", id: "about" },
  { label: "Areas", id: "areas" },
];

export const CONTACT_EMAIL = "wojciech.arseniuk@ou.ac.uk";
